import {Injectable} from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ReportPerformService {

  private reportUrl = `${ environment.apiRoot }/report-perform/`;
  private inviteUrl = `${ environment.apiRoot }/perform-invite/`;

  constructor(private http: HttpAuth) { }

  public getReportPerformByid(performId: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (performId != null) {
      params.append('performid', String(performId));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.reportUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getReportPerformBydate(performId: string, date: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (performId != null) {
      params.append('perform_id', String(performId));
    }

    if (date != null) {
      params.append('perform_date', String(date));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.inviteUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putReportPerform(perform_id: string, description: string, appliers: any, date: string, email = ''): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    let params: URLSearchParams = new URLSearchParams();
    let data = {};
    if (email == '') {
      data = {
        'perform_id' : perform_id,
        'more_info' : description,
        'appliers' : appliers,
        'perform_date': date
      }
    }else{
      data = {
        'perform_id' : perform_id,
        'more_info' : description,
        'appliers' : appliers,
        'email' : email,
        'perform_date': date
      }
    }

    let options = new RequestOptions({search: params});

    return this.http.put(this.reportUrl, data, {headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postReportPerform(perform_id:string, description:string, appliers:any, date: string,  email = ''): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    let params: URLSearchParams = new URLSearchParams();
    let data = {};
    if (email == ''){
      data = {
        'perform_id' : perform_id,
        'more_info' : description,
        'appliers' : appliers,
        'perform_date': date
      }
    }else{
      data = {
        'perform_id' : perform_id,
        'more_info' : description,
        'appliers' : appliers,
        'perform_date': date,
        'email' : email,
      }
    }

    let options = new RequestOptions({search: params});

    return this.http.post(this.reportUrl, data,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/report-perform.service.ts